import SecondaryWalletTypeGeneralSettings from "@/models/Products/ProductSettings/SecondaryWallets/General/SecondaryWalletTypeGeneralSettings";
import SecondaryWalletTypeViewModel from "@/models/Products/ProductSettings/SecondaryWallets/General/SecondaryWalletTypeViewModel";

export default class UpdateSecondaryWalletTypeGeneralSettingsRequest extends SecondaryWalletTypeGeneralSettings {

    public constructor(secondaryWalletTypeViewModel: SecondaryWalletTypeViewModel) {
        super();
        this.overridable = secondaryWalletTypeViewModel.generalSettings.overridable;
        this.enabled = secondaryWalletTypeViewModel.generalSettings.enabled;
        this.code = secondaryWalletTypeViewModel.generalSettings.code;
        this.name = secondaryWalletTypeViewModel.generalSettings.name;
        this.allowedCurrencies = secondaryWalletTypeViewModel.generalSettings.allowedCurrencies;
    }
}